export const SHARED_WINDOW_HEIGHT = 225;

export const DRAWER_WIDTH = 422;

//TODO: eliminate if it's not used
export const CHAT_DRAWER_WIDTH = {
  TWO_TABS: 360,
  THREE_TABS: 360,
};

//EventScheduler
export const MINUTES_ALLOW_TO_JOIN = 15;
export const MINUTES_ALLOW_TO_JOIN_HOST = 30;
